












































import Vue from 'vue';
import MemberDataResourceViewModel from '@/src/services/viewModel/resource/MemberDataResourceViewModel';

export default Vue.extend({
  auth: true,
  data: () => ({
    isLoading: false,
    requestError: undefined,
    membershipData: new MemberDataResourceViewModel(),
  }),
  async beforeMount() {
    this.isLoading = true;
    try {
      this.membershipData = await this.$service.api.memberships.getMyMembership() ?? new MemberDataResourceViewModel();
    } catch (error: any) {
      this.requestError = error;
    }
    this.isLoading = false;
  },
  methods: {
    navigateBackToOverview() {
      this.$router.push('/syna/memberPortal/member-data');
    },
  },
});
